import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-ho-medical-underwritting',
    templateUrl: './ho-medical-underwritting.component.html',
    styleUrls: ['./ho-medical-underwritting.component.scss'],
    imports: [RouterOutlet]
})
export class HoMedicalUnderwrittingComponent  {

  constructor() { }


}
